import gql from 'graphql-tag';

export const GetApplicationEventsByIdQuery = gql`
  query GetApplicationEventsByIdQuery($applicationId: String) {
    applicationEvents(applicationId: $applicationId) {
      eventId
      _Ebb_ApplicationId
      eventId
      name
    }
  }
`;